import React from 'react';
import { FormSelect, MasterDetailForm } from '@digital/ui';

import { PostGerenteArea } from '@app/api/sas/ordemCompra';
import { hasPermission } from '@app/helpers/permissions';
import { gerenteAreaOptionsState } from '../atoms';
import { useRecoilValue } from 'recoil';

interface Props {
  ordemCompraId: string;
  gerenteAtualId: string;
  onUpdateDadosGerais: () => void;
  statusDisable: boolean;
}

const SelectIncluirGerenteArea: React.FC<Props> = ({
  ordemCompraId,
  gerenteAtualId,
  onUpdateDadosGerais,
  statusDisable,
}: Props) => {
  const gerenteAreaOptions = useRecoilValue(gerenteAreaOptionsState);

  const onSelected = (gerenteAreaId: string) => {
    PostGerenteArea({
      ordemCompraId: ordemCompraId,
      gerenteAreaId: gerenteAreaId,
    }).then(() => {
      onUpdateDadosGerais();
    });
  };

  return (
    <MasterDetailForm key="SelectIncluirGerenteAreaForm" initialValues={{ gerenteAtualId }}>
      <FormSelect
        options={gerenteAreaOptions}
        onSelect={(e: any) => onSelected(e)}
        name="gerenteAtualId"
        label="Gerente Geral"
        span={4}
        disabled={!hasPermission(['SAS_ALTERAR_GERENTE_AREA']) || !statusDisable}
        showSearch
        filterOption={(input, item: any) => {
          return item.props.children.props.id.toString().toLowerCase().startsWith(input.toLowerCase());
        }}
      />
    </MasterDetailForm>
  );
};

export default SelectIncluirGerenteArea;
